import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { ANALYTIC_INVENTORY_RISK_METRIC } from 'modules/reports/interfaces/IReportInventoryRisk';

class AnalyticInventoryRiskService extends EntityApiService<any> {
  searchAnalytic = (
    metric: ANALYTIC_INVENTORY_RISK_METRIC,
    params?: any,
    config?: RequestConfig,
  ) =>
    this.handleResponse(
      ApiClientService.post(this.getPath(`/${metric}`), params, config),
    );
}

export default new AnalyticInventoryRiskService(
  '/ms-analytics/api/v1/inventory-risk-analytic',
);
